<template>
  <button 
    v-if="isButtonVisible"
    :id="'attendee-text-chat-request-' + attendee.event_attendee_id"
    :data-event-attendee-id="attendee.event_attendee_id"
    class="directory-schedule-container__button schedule-btn networking-btn btn"
    data-keyboard="false"
    title="Send a message button"
    aria-label="Send a message button"
    @click="handleMessage"
  >
    <i class="fal fa-comment-dots mr-2"></i>
    {{ buttonText }}
  </button>
</template>


<script>
export default {
  props: {
    directory: {
      type: Object,
      required: true
    },
    currentAttendee: {
      type: Object,
      required: true
    },
    attendee: {
      type: Object,
      required: true
    },
    buttonText: {
      type: String,
      default: 'event_strings.directories.send_message_button'
    }
  },
  computed: {
    isButtonVisible() {
      return this.directory.add_send_direct_message_button &&
             this.currentAttendee.id !== this.attendee.event_attendee_id;
    }
  },
  methods: {
    handleMessage() {
      window.EventBus.$emit('chat-button-clicked', this.attendee.event_attendee_id);
    }
  }
};
</script>
